import React, { Fragment, h } from "preact";
import './Table.scss';

export default function TableRow ({children, full, className}) {
    const classNameStyle = className ? className : 'default';

    return (
        <div className={`component-table__row ${full ? 'component-table__row--full' : ''} ${classNameStyle}`}>
            {children}
        </div>
    )
}